module.exports = __webpack_public_path__ + "img/arrow-right.17425c9.svg";